import { theMysteriousDoor } from './the-mysterious-door'
import type { BranchingStory } from '@/types/storytelling'

export const branchingStories: BranchingStory[] = [theMysteriousDoor]

export function getBranchingStory(id: string): BranchingStory | undefined {
  return branchingStories.find((s) => s.id === id)
}
